import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthenticationStore, { AuthenticationViews } from './Store';
import VerifyNonce from './VerifyNonce';

const VerifyNonceContainer: React.FC = () => {
  const { state, forgotPassword, verifyPasswordResetNonce } = useAuthenticationStore()
  const { isLoading, serverError, emailOrPhone } = state
  const navigate = useNavigate()


  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
    }
  }, [emailOrPhone, navigate])

  return (
    <VerifyNonce
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      verifyPasswordResetNonce={verifyPasswordResetNonce}
      forgotPassword={forgotPassword}
    />
  )
}

export default VerifyNonceContainer